import { Compass, Filter, Settings, X } from "lucide-react";
import MenuIconBadge from "./MenuIconBadge";
import MenuIconTooltip from "./MenuIconTooltip";
import { MENU_MIDDLE_TOOLTIPS, MENU_MODE_TOOLTIPS } from "../constants/menuTooltips";

function RegisterCompassButton({
  active = false,
  onClick,
  packsUnread = 0,
  packsAlert = false,
}) {
  const compassClass = active
    ? "filterIcon menuGaucheContainer__packs active"
    : "filterIcon menuGaucheContainer__packs";

  return (
    <MenuIconTooltip
      tooltip={MENU_MODE_TOOLTIPS.packs}
      placement="above"
      portal
      className={compassClass}
    >
      <span className="menu-icon-badge-wrap menuGaucheContainer__packs-icon">
        <Compass
          size={50}
          color="#39210d"
          strokeWidth={1}
          onClick={onClick}
          aria-label={MENU_MODE_TOOLTIPS.packs}
          style={{ cursor: "pointer", display: "block" }}
        />
        {packsUnread > 0 && <MenuIconBadge count={packsUnread} />}
        {packsUnread === 0 && packsAlert && <MenuIconBadge alert />}
      </span>
    </MenuIconTooltip>
  );
}

function RecencySettingsButton({ active = false, onClick }) {
  const settingsClass = active
    ? "filterIcon menuGaucheContainer__packs active"
    : "filterIcon menuGaucheContainer__packs";

  return (
    <MenuIconTooltip
      tooltip={MENU_MIDDLE_TOOLTIPS.settings}
      placement="above"
      portal
      className={settingsClass}
    >
      <span className="menuGaucheContainer__packs-icon">
        <Settings
          size={50}
          color="#39210d"
          strokeWidth={1}
          onClick={onClick}
          aria-label="Paramètres de la récence"
          style={{ cursor: "pointer", display: "block" }}
        />
      </span>
    </MenuIconTooltip>
  );
}

export default function MenuLeft({
  activeFilter,
  mode = "register",
  filterSubActive = false,
  showFilter = true,
  showPacks = true,
  showRecencySettings = false,
  recencySettingsActive = false,
  onFilterClick,
  onFilterClear,
  onPacksClick,
  onRecencySettingsClick,
  packsUnread = 0,
  packsAlert = false,
}) {
  const canFilter =
    showFilter &&
    mode === "register" &&
    (activeFilter === "success" || activeFilter === "info");

  const packsActive = mode === "packs";

  let wrapperClass = "filterIcon";
  if (filterSubActive) {
    wrapperClass += " active";
  }

  const ariaLabel =
    activeFilter === "info"
      ? "Filtrer le registre des mots"
      : "Filtrer les mots correctement restitués";

  const filterPlaceholder = (
    <div
      className="filterIcon filterIcon--enabled menuGaucheContainer__filter-slot"
      aria-hidden="true"
    >
      <Filter size={38} color="#39210d" strokeWidth={1} />
    </div>
  );

  return (
    <div className="menuGaucheContainer">
      {showRecencySettings ? (
        <RecencySettingsButton
          active={recencySettingsActive}
          onClick={onRecencySettingsClick}
        />
      ) : showPacks ? (
        <RegisterCompassButton
          active={packsActive}
          onClick={onPacksClick}
          packsUnread={packsUnread}
          packsAlert={packsAlert}
        />
      ) : null}

      {mode === "packs" || (showFilter && !canFilter) ? (
        filterPlaceholder
      ) : showFilter ? (
        <div className={wrapperClass}>
          <span className="menu-icon-badge-wrap">
            <Filter
              size={38}
              color="#39210d"
              strokeWidth={1}
              onClick={onFilterClick}
              aria-label={ariaLabel}
              style={{ cursor: "pointer" }}
            />
            {filterSubActive && onFilterClear ? (
              <button
                type="button"
                className="menu-filter-clear"
                aria-label="Retirer le filtre"
                onClick={(event) => {
                  event.preventDefault();
                  event.stopPropagation();
                  onFilterClear();
                }}
              >
                <X size={11} strokeWidth={3} aria-hidden="true" />
              </button>
            ) : null}
          </span>
        </div>
      ) : null}
    </div>
  );
}
